"use client";

import BasicButton from "@/components/buttons/basic_button/basic_button";
import LinkButton from "@/components/buttons/link_button/link_button";
import EnterText from "@/components/enter-text/enter_text";
import style from "./page.module.css";
import React, { useState } from "react";
import { isValidEmail } from "@/util/functions";
import { UserLoginType } from "@/types/users.types";
import { BackendApi } from "@/api/backend-api/backend.api";
import { NextResponse } from "next/server";
import { localStorageSetItems } from "@/lib/localStorage.api";

export default function LoginPage() {
  const [userLoginData, setUserLoginData] = useState({
    email: "",
    password: "",
  });

  const backendApi = new BackendApi();

  function updateUserEmail(text: string) {
    const copyUserLoginData = { ...userLoginData };
    setUserLoginData({ ...copyUserLoginData, email: text });
  }

  function updateUserPassword(text: string) {
    const copyUserLoginData = { ...userLoginData };
    setUserLoginData({ ...copyUserLoginData, password: text });
  }

  async function loginUserData() {

    if (userLoginData.email.length <= 0 || userLoginData.password.length <= 0) {
      alert("이메일 또는 비밀번호를 입력해 주시기 바랍니다.");
      return;
    } else {
      if (!isValidEmail(userLoginData.email)) {
        alert("제대로된 이메일 입력");
        return;
      } else {
        try {
          const tokenData: UserLoginType = await backendApi.loginEmailUser(
            userLoginData.email,
            userLoginData.password,
          );

          let token: string = '';

          if (tokenData.success) {
            token = tokenData.data;
          }

          console.log("tokenData : ", tokenData);

          if (!token) return;

          // 저장
          localStorageSetItems({ token });

          console.log("로그인 성공 : /main-page로 이동");

          window.location.href = '/main-page';



          return NextResponse.json({
            message: '로그인 성공'
          }, {
            status: 200
          })

        } catch (err: any) {

          return NextResponse.json({
            message: err['message']
          }, {
            status: err['statusCode']
          })

        }

      }
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    console.log("Enter Keyboard : ", e.key);
    if (e.key === "Enter") {
      loginUserData()
    }
  }

  return (
    <div className={style.loginBackground}>
      <div className={style.loginPage}>
        <h1>* 관리자 로그인 *</h1>
        <EnterText
          type="email"
          width="200px"
          height="25px"
          placeholder="이메일 주소"
          func={updateUserEmail}
          onKeyDown={handleKeyDown}
        />
        <EnterText
          type="password"
          width="200px"
          height="25px"
          placeholder="비밀번호"
          func={updateUserPassword}
          onKeyDown={handleKeyDown}
        />
        <BasicButton
          name="로그인"
          width="200px"
          height="40px"
          color="#FFFFFF"
          background="#1354ED"
          padding="10px 10px"
          // color="C1BCC1"
          func={loginUserData}
        />
        <div className={style.linkBtns}>
          <LinkButton name="비밀번호 찾기" href="/find_password" />
          <LinkButton name="이메일 찾기" href="/find_email" />
          <LinkButton name="회원가입" href="/signup" />
        </div>
      </div>
    </div>
  );
}
